export default __webpack_public_path__ + "static/media/authorbg03.7795655b.jpg";